import styled from 'styled-components';
import { OrderPanelStyled } from '../../OrderPanelStyled';
import { rem } from 'polished';

export const OrderPanelStyledOV = styled(OrderPanelStyled)`
    background: ${({ theme }) => theme.colors.grey7};

    .priceSection {
        .catalogPrice {
            font-size: ${({ theme }) => theme.fontSizes.h7};
        }

        .price {
            font-size: ${rem(16)};
        }

        .currencyLabel__suffix--OTR,
        .currencyLabel__suffix--PM {
            font-size: ${({ theme }) => theme.fontSizes.h7};
        }
    }

    .benefitSection {
        &.desktop {
            border-left: 1px solid ${({ theme }) => theme.colors.grey16};
        }
    }

    .buttonSection {
        border-left: 1px solid ${({ theme }) => theme.colors.grey16};

        .links {
            button {
                color: ${({ theme }) => theme.colors.black};

                &:hover {
                    color: ${({ theme }) => theme.colors.primary};
                    border-bottom: 1px solid ${({ theme }) => theme.colors.primary};

                    .icon-wrapper {
                        svg {
                            path {
                                fill: ${({ theme }) => theme.colors.primary};
                            }
                        }
                    }
                }

                .icon-wrapper {
                    svg {
                        margin-bottom: ${rem(1)};

                        path {
                            fill: ${({ theme }) => theme.colors.black};
                        }
                    }
                }
            }
        }
    }

    .desktopContactSection {

        .phoneLink {
            color: ${({ theme }) => theme.colors.black2};
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.black2};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};

        .label {
            svg {
                margin-left: ${rem(5)};
            }
        }

        .phone {
            svg {
                width: ${rem(30)};
                height: ${rem(15)};
                margin-right: ${rem(5)};
                margin-bottom: ${rem(4)};

                path {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
`;
